<template>
  <div style="padding: 10px 10px 0px">
    <p align="center">
      <small>
        <span class="span-information" style="display:block">
          <span v-if="isShowProp('city')" style="padding: 0 2px">{{profile.city}}</span>
          <span v-if="isShowProp('city') && isShowProp('province')" class="dot-stl">&middot;</span>
          <span v-if="isShowProp('province')" style="padding: 0 2px">{{profile.province}}</span>
          <span v-if="isShowProp('region') && isShowProp('province')" class="dot-stl">&middot;</span>
          <span v-if="isShowProp('region')" style="padding: 0 2px">{{profile.region}}</span>
          <span v-if="isShowProp('zipcode') && isShowProp('region')" class="dot-stl">&middot;</span>
          <span v-if="isShowProp('zipcode')" style="padding: 0 2px">{{profile.zipcode}}</span>
          <span v-if="isShowProp('zipcode') && isShowProp('country')" class="dot-stl">&middot;</span>
          <span @click="viewResource(countryId)" v-if="isShowProp('country')" style="padding: 0 2px">{{profile.country}}</span>
        </span>
      </small>
    </p>
    <p align="center">
      <small>
        <span class="span-information" style="display:block">
          <span v-if="isShowProp('email')" style="padding: 0 2px">{{profile.email}}</span>
          <span v-if="isShowProp('email') && isShowProp('contact_number')" class="dot-stl">&middot;</span>
          <span v-if="isShowProp('contact_number')" style="padding: 0 2px">{{profile.contact_number}}</span>
        </span>
        <span class="span-information" style="display:block">
          <span v-if="isShowProp('gender')" style="padding: 0 2px">{{profile.gender}}</span>
          <span v-if="isShowProp('age_bracket') && isShowProp('gender')" class="dot-stl">&middot;</span>
          <span v-if="isShowProp('age_bracket')" style="padding: 0 2px">{{profile.age_bracket}}</span>
          <span v-if="isShowProp('age_bracket') && isShowProp('employment_status')" class="dot-stl">&middot;</span>
          <span v-if="isShowProp('employment_status')" style="padding: 0 2px">{{profile.employment_status}}</span>
        </span>
      </small>
    </p>
    <!-- <ContentLoading v-show="loading" :height="40" style="margin:0px 5px 0px 5px;">
      <rect x="90" y="15" rx="4" ry="4" width="60%" height="6" class="order-1" />
      <rect x="120" y="25" rx="4" ry="4" width="40%" height="6" class="order-2" />
      <rect x="150" y="35" rx="4" ry="4" width="20%" height="6" class="order-3" />
    </ContentLoading> -->
  </div>
</template>

<script>
import ContentLoading from 'vue-content-loading';

export default {
  components: { 
    ContentLoading
  },
  props: {
    profile: {
      type: Object
    },
    countryId: {
      type: String
    },
    loading: {
      type: Boolean,
      required: false,
      default: false      
    }
  },
  methods: {
    isShowProp(v) {
      if(this.profile && this.profile['visible_fields'] && v)
        return ( this.profile['visible_fields'].indexOf(v) > -1 )
      return true
    },
    viewResource(id) {
      this.$router.push('/resources/'+id)
    }
  },
  mounted() {
    console.log(this.profile)
  }
}
</script>

<style>
  .dot-stl {
    font-size:20px;
    line-height:10px;
    vertical-align:middle;
  }

  .span-information span {
    vertical-align: middle;
  }
</style>
